var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF536D",
    strokeWidth: 2,
    d: "M2.996 11.937c0-3.724 0-5.586.949-6.892a4.966 4.966 0 0 1 1.098-1.099c1.306-.948 3.168-.948 6.892-.948 3.725 0 5.587 0 6.892.948.422.307.793.678 1.099 1.1.948 1.305.948 3.167.948 6.891 0 3.725 0 5.587-.948 6.892a4.968 4.968 0 0 1-1.099 1.099c-1.305.948-3.167.948-6.892.948-3.724 0-5.586 0-6.892-.948a4.968 4.968 0 0 1-1.098-1.099c-.949-1.305-.949-3.168-.949-6.892Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF536D",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m4.5 19.5 7.172-7.171a4 4 0 0 1 5.656 0L20.5 15.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF536D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.496 24.013c1.36.99 3.302.99 7.185.99 3.882 0 5.823 0 7.184-.99.44-.319.826-.705 1.145-1.145.99-1.36.99-3.302.99-7.184 0-3.883 0-5.824-.99-7.185"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "#FF536D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.9cd58eaedf7fecf1282ae40feae9529f.svg";
export { ForwardRef as ReactComponent };